module.exports = __webpack_public_path__ + "img/arrow_down.88b368dc.svg";